/* ============
 * News Transformer
 * ============
 */

import Transformer from './transformer';

export default class NewsTransformer extends Transformer {

  static fetch(news) {
    return {
      id: news.id,
      subject: news.subject,
      body: news.body,
      sent: news.sent,
      sendAfterDate: news.send_after_date,
      sendAfter: news.send_after,
      newsCampaignId: news.news_campaign_id,
      newsStatusId: news.news_status_id,
      status: news.status,
      emailSendTracking: news.email_send_tracking,
      sentSuccess: news.sent_success,
      sentFailed: news.sent_failed,
      testEmail: news.custom_test_email,
      htmlEmail: news.html_email,
    };
  }

  static send(news) {
    return {
      id: news.id,
      subject: news.subject,
      body: news.body,
      send_after_date: news.sendAfterDate,
      campaign_type: news.campaignType,
      send_after: news.sendAfter,
      news_campaign_id: news.newsCampaignId,
      news_status_id: news.newsStatusId,
      custom_test_email: news.testEmail,
      test_email_check: news.testEmailCheck,
      html_email: news.htmlEmail,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/news.js